import {QuickbetXReserveAction, QuickbetXReserveState, QuickbetXReserveActionTypes} from "../../types/QuickbetX/quickbetXReserveTypes";

const initialState: QuickbetXReserveState = {
    quickbetXReserveData: [],
    quickbetXReserveDataLoading: false,
    quickbetXReservedError: null,
};

export const quickbetXReserveReducer = (state = initialState, action: QuickbetXReserveAction): QuickbetXReserveState => {
    switch (action.type) {
        case QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA:
            return { ...state, quickbetXReserveDataLoading: true, quickbetXReservedError: null, quickbetXReserveData: [] };
        case QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_SUCCESS:
            return { ...state, quickbetXReserveDataLoading: false, quickbetXReservedError: null, quickbetXReserveData: action.payload };
        case QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_ERROR:
            return { ...state, quickbetXReserveDataLoading: false, quickbetXReservedError: action.payload, quickbetXReserveData: [] };
        default:
            return state;
    }
};
